import React, {useEffect, useState} from "react";
import $ from 'jquery';
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import swal from "sweetalert";
import _ from "lodash";
import '../../assets/css/pages/seller-applications.css'

export default function () {
  const navigate = useNavigate();
  const [bulkArray, setBulkArray] = useState([]);
  const buttonIsDisabled = !bulkArray.length;
  const token = useSelector(state => state.token);


  const deleteRow = (table, selector) => {
    table
      .row(selector.parents('tr'))
      .remove()
      .draw(false);
  }

  useEffect(() => {
    $('#seller-applications thead tr')
      .clone(true)
      .addClass('filters display-none')
      .appendTo('#seller-applications thead');

    let table = $('#seller-applications').DataTable({
      "destroy": true,
      "ajax": {
        url: process.env.REACT_APP_API_URL + "seller-applications",
        method: 'GET',
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.defaults.baseURL = process.env.REACT_APP_API_CLEAN_URL;
            axios.post('/logout')
              .then(
                localStorage.removeItem('persist:root'),
                navigate('/login')
              );
          }
        }
      },
      initComplete: function () {
        var api = this.api();

        // For each column
        api
          .columns()
          .eq(0)
          .each(function (colIdx) {
            // Set the header cell to contain the input element
            var cell = $('.filters th').eq(
              $(api.column(colIdx).header()).index()
            );
            var title = $(cell).text();
            $(cell).html('<input type="text" placeholder="' + title + '" />');

            // On every keypress in this input
            $(
              'input',
              $('.filters th').eq($(api.column(colIdx).header()).index())
            )
              .off('keyup change')
              .on('keyup change', function (e) {
                e.stopPropagation();

                // Get the search value
                $(this).attr('title', $(this).val());
                var regexr = '({search})'; //$(this).parents('th').find('select').val();

                var cursorPosition = this.selectionStart;
                // Search the column for that value
                api
                  .column(colIdx)
                  .search(
                    this.value != ''
                      ? regexr.replace('{search}', '(((' + this.value + ')))')
                      : '',
                    this.value != '',
                    this.value == ''
                  )
                  .draw(false);

                $(this)
                  .focus()[0]
                  .setSelectionRange(cursorPosition, cursorPosition);
              });
          });
      },
      "columns": [
        {
          data: 'checkbox',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return `
                    <label class="form-label-checkbox fs-6 fw-bolder text-dark">
                      <input class="checkbox list" type="checkbox" label="My Value" name="primary" row-id="${row.id}">
                      <span class="checkmark"></span>
                    </label>`;
          },
        },
        {data: 'id', name: 'id'},
        {data: 'company_name', name: 'company_name'},
        {data: 'company_id', name: 'company_id'},
        {data: 'name', name: 'name'},
        {data: 'surname', name: 'surname'},
        {data: 'phone', name: 'phone'},
        {
          data: 'actions', searchable: false, sortable: false,
          render: function (data, type, row) {
            return `
                    <button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-primary me-2 mb-4 mt-1 view"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="fas fa-edit"></i> View
                            </button>
                             <button 
                            class="btn btn-danger me-2 mb-1 delete"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="far fa-trash-alt"></i> Delete
                            </button>
                        <div>
                    </div>
                    `;
          },
        }
      ],
      "order": [[1, "desc"]],
    });

    table.off('click');

    table.on('click', 'button.actions', function () {
      if ($(this).next(".row-actions").hasClass("hidden-actions")) {
        $(this).next(".row-actions").fadeIn(100).removeClass("hidden-actions");
      } else {
        $(this).next(".row-actions").fadeOut(100).addClass("hidden-actions");
      }
    });


    table.on('click', 'button.delete', function () {
      const id = ($(this).attr("row-id"));
      const name = ($(this).attr("row-name"));
      $(".row-actions").fadeOut(100).addClass("hidden-actions");
      deleteApplication(id, name, table, $(this));
    });

    table.on('click', 'button.view', function () {
      const id = ($(this).attr("row-id"));
      navigate('/seller-applications/' + id);
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");

    table.on('click', '.form-label-checkbox .checkbox', function () {
      const id = ($(this).attr("row-id"));
      setBulkArray(cur => _.xor(cur, [id]));
    });

    $('.toggle-filter').each(function () {
      if ($(this).css('display') == 'block') {
        $(".table-filter-icon").html("<i class='far fa-times-circle fs-4 br-1000'></i>Close");
      }
    });

    table.on('click', '.form-label-checkbox .checkbox.mark-all', function () {
      if ($(this).is(':checked')) {
        setBulkArray([]);
        let allId = [];
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == false) {
            $(this).click();
          }
          allId.push($(this).attr("row-id"));
        });
        setBulkArray(allId);
      } else {
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == true) {
            $(this).click();
          }
        });
        setBulkArray([]);
      }
    });

    table.on('draw', function () {
      $(".pagination .page-item").click(function () {
        resetMarked();
      });
      resetMarked();
      $(".form-label-checkbox #mark-all").click().click();
    });

    $("table.dataTable thead tr:first-child th:nth-child(1)")
      .html(`<label class="form-label-checkbox form-label-checkbox-mark-all  fs-6 fw-bolder text-dark pt-0">
           <input class="checkbox mark-all" type="checkbox" id="mark-all" label="My Value" name="primary">
           <span class="checkmark"><span></span></span>
           </label>`);

  }, []);

  const resetMarked = () => {
    if ($(".form-label-checkbox .checkbox.mark-all").is(":checked")) {
      $(".form-label-checkbox .checkbox.mark-all").click();
    }
    $(".form-label-checkbox .checkbox.list").each(function (index) {
      if ($(this).is(':checked') == true) {
        $(this).click();
      }
    });
    setBulkArray([]);
  }

  const deleteApplication = (id, name, table, selector) => {
    swal({
      title: "Are you sure?",
      text: 'You want to delete application ?',
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result == true) {
        axios.delete('seller-applications/' + id, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        }).then(function (res) {
          if (res.status == 200) {
            swal('The Application has been deleted!', {
              icon: "success",
            });
            deleteRow(table, selector);
            return true;
          } else {
            return false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    });
  }

  const bulkDelete = () => {
    swal({
      title: "Are you sure?",
      text: `You want to delete marked application?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      console.log(result);
      if (result == true) {
        axios.post('seller-applications/bulk-destroy', {
          applications: bulkArray,
        })
          .then(function (res) {
            if (res.status == 200) {
              swal(`Applications has been deleted successfully!`, {
                icon: "success",
              });

              resetMarked();
              $('#seller-applications').DataTable().draw(false);
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.data.errors);
            }
          });
      }
    });
  }

  return (
    <>
      <div>
        <div className="text-right pb-3">
          <div className={`marked-actions d-inline-block ${buttonIsDisabled ? " d-none" : ""}`}>
            <span className="d-inline-block border-end pr-3 mr-3">
              <button
                type="button"
                className="btn btn-danger br-12-5-px w-10-rem"
                onClick={() => bulkDelete()}
                disabled={buttonIsDisabled}
              >
                <i className="far fa-trash-alt fs-5 mr-2"></i> Delete
              </button>
            </span>
          </div>
        </div>

        <table id="seller-applications" className="table align-middle table-row-dashed fs-6 gy-5">
          <thead>
          <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
            <th></th>
            <th>ID</th>
            <th>Company name</th>
            <th>Company Id</th>
            <th>Name</th>
            <th>Surname</th>
            <th>Phone</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody className="text-gray-600 fw-bold"></tbody>
        </table>
      </div>
    </>
  );
}